import React from 'react';
import { motion } from 'framer-motion';
import { Bloom } from './Bloom';
type PageHeaderProps = {
  label: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  children?: React.ReactNode;
};
export function PageHeader({
  label,
  title,
  intro,
  children
}: PageHeaderProps) {
  return <header className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-489" data-mp="3mfslxn9cphpn">
      <Bloom size="lg" className="left-1/2 top-[-14rem] -translate-x-1/2" data-id="element-490" data-mp="2ypy8p4l4dr4v" />
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-491" data-mp="2ynu56nr4uu54">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-492" data-mp="2ts6fm78qnyz3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500" data-id="element-493" data-mp="33ohth1nz8wvn">
            {label}
          </p>
          <h1 className="mt-6 max-w-3xl text-4xl font-bold leading-[1.08] tracking-tight text-white sm:text-5xl" data-id="element-494" data-mp="2fyf8f5ihcr6j">
            {title}
          </h1>
          {intro && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-neutral-400" data-id="element-495" data-mp="2hzhwepx7qhfc">{intro}</p>}
          {children && <div className="mt-9" data-id="element-496" data-mp="2lzia28chmolc">{children}</div>}
        </motion.div>
      </div>
    </header>;
}